import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import useSubmitBranchWithCode from 'api/productDetail/useSubmitBranchWithCode/useSubmitBranchWithCode';
import React, { useEffect, useState } from 'react';

const BranchWithCodeSubmitModal = ({ open, handleClose, originGuid }) => {
  const [codeValue, setCodeValue] = useState('');
  const [emptyError, setEmptyError] = useState(false);

  const [submitBranchWithCode, loading] = useSubmitBranchWithCode();

  const onClose = () => {
    handleClose();
    setCodeValue('');
  };

  const submitBranch = () => {
    if (codeValue) {
      setEmptyError(false);
      submitBranchWithCode(originGuid, codeValue, () => onClose());
    } else {
      setEmptyError(true);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ثبت برنچ با کد</DialogTitle>

      <DialogContent sx={{ width: '500px' }}>
        <FilledWrapper>
          <FilledLabel>کد</FilledLabel>
          <TextField
            autoFocus
            variant="standard"
            value={codeValue}
            onChange={e => setCodeValue(e.target.value)}
            sx={{ width: 'calc(100% - 80px)' }}
            error={!codeValue && emptyError}
          />
        </FilledWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button onClick={handleClose} variant="contained" disabled={loading}>
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitBranch}
          loading={loading}
        >
          ثبت
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BranchWithCodeSubmitModal;

const FilledWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledLabel = styled.label``;
